
import { TextField } from '@mui/material';
import './pelak.css';
import React, { useEffect, useState } from 'react';
  
const PlaqueInfos : PlaqueInfo[] = [
  {
    type: "public",
    letter: "ع",
    bg: "#ffca0b",
    text: "#000000",
  },
  {
    type: "taxi",
    letter: "ت",
    bg: "#ffca0b",
    text: "#000000",
  },
  {
    type: "governmental",
    letter: "الف",
    bg: "#ee161f",
    text: "#ffffff",
  },
  {
    type: "temporary",
    letter: "گ",
    bg: "#ffffff",
    text: "#000000",
  },
  {
    type: "handicapped",
    letter: "ژ",
    bg: "#ffffff",
    text: "#000000",
  },
  {
    type: "ministry",
    letter: "ز",
    bg: "#0079c1",
    text: "#ffffff",
  },
  {
    type: "diplomatic",
    letter: "D",
    bg: "#00a2e8",
    text: "#000000",
  },
  {
    type: "service",
    letter: "S",
    bg: "#00a2e8",
    text: "#000000",
  },
  {
    type: "headquarter",
    letter: "ف",
    bg: "#0079c1",
    text: "#ffffff",
  },
  {
    type: "military",
    letter: "ش",
    bg: "#cfa260",
    text: "#000000",
  },
  {
    type: "sepah",
    letter: "ث",
    bg: "#005224",
    text: "#ffffff",
  },
  {
    type: "police",
    letter: "پ",
    bg: "#005224",
    text: "#ffffff",
  },
  {
    type: "agriculture",
    letter: "ک",
    bg: "#ffca0b",
    text: "#000000",
  },
  {
    type: "agriculture",
    letter: "ك",
    bg: "#ffca0b",
    text: "#000000",
  },
  {
    type: "personal",
    letter: "",
    bg: "#ffffff",
    text: "#000000",
  }
];

interface PlaqueInfo {
  type:
      "public"
    | "governmental"
    | "personal"
    | "handicapped"
    | "taxi"
    | "police"
    | "sepah"
    | "military"
    | "ministry"
    | "headquarter"
    | "agriculture"
    | "temporary"
    | "diplomatic"
    | "service";
  letter: string;
  bg: string;
  text: string;
}

interface IPlaqueProp{
  Plaque1?: string;
  Plaque2?: string;
  Plaque3?: string;
  Plaque4?: string;
  vehicleNo?: string;
  readonly?: boolean;
  onVehicleNoSet?: any;
  onPlaqueSet?: any;
  fontSizeFactor?: number
}

const IsePelak = (props: IPlaqueProp) => {
  //const [values, setValues] = useState<IPlaqueProp>({...props, Plaque2: props.Plaque2 ?? 'ع'});
  const [values, setValues] = useState<IPlaqueProp>(props);
  const { fontSizeFactor , onPlaqueSet, onVehicleNoSet } = props;
  const fc = (fontSizeFactor || 1);

  useEffect(() => {
    setValues(props);
    if(!props.Plaque2 && !values.Plaque2){
      setValues({...props, Plaque2 : (props.Plaque2 && props.Plaque2?.length > 0) ? props.Plaque2 : 'ع' });
    }
  }, [])
  
  useEffect(() => {    
    if(props.vehicleNo?.length === 13 && ((props.Plaque1?.length ?? 0) + (props.Plaque2?.length?? 0) + (props.Plaque3?.length ?? 0) + (props.Plaque4?.length ?? 0) === 0))
    {
      setValues({...values,
        Plaque1: props.vehicleNo.slice(11,13),
        Plaque2: props.vehicleNo.slice(10,11),
        Plaque3: props.vehicleNo.slice(7,10),
        Plaque4: props.vehicleNo.slice(0,2)})
    }
  }, [props.vehicleNo])
  
  const getPelakBgColor = (letter? : string) => {
    const bg = PlaqueInfos.find( i => i.letter === letter)?.bg;
    return bg ? bg : '#ffffff';
  }

  const getPelakColor = (letter? : string) => {
    const txt = PlaqueInfos.find( i => i.letter === letter)?.text;
    return txt ? txt : '#000000';
  }

  const onChangePlq1 = (letter :string ) => {
    if(letter.length <= 2){
      setValues({...values, Plaque1: letter});
    }
    else{
      setValues({...values, Plaque1: values.Plaque1});
    }
  }

  const onChangePlq2 = (letter :string ) => {
    if(['الف', 'ب','ج','د','س','ص','ط','ق','ل','م','ن','و','ه‍','ه','ی','ي','ك','ک','پ','ت','ث','ز','ژ','ش','ع','ف','گ','D','S'].some( i => i === letter)){
      setValues({...values, Plaque2: letter});
    }
    else{
      setValues({...values, Plaque2: ""});
    }
  }

  const onChangePlq3 = (letter :string ) => {
    if(letter.length <= 3){
      setValues({...values, Plaque3: letter});
    }
    else{
      setValues({...values, Plaque3: values.Plaque3});
    }
  }

  const onChangePlq4 = (letter :string ) => {
    if(letter.length <= 2){
      setValues({...values, Plaque4: letter});
    }
    else{
      setValues({...values, Plaque4: values.Plaque4});
    }
  }

  useEffect(() => {
    if(values.onPlaqueSet){
      onPlaqueSet(values.Plaque1,values.Plaque2,values.Plaque3,values.Plaque4);
    }

    if(values.onVehicleNoSet ){
      if( values.Plaque1?.length === 2 && values.Plaque2?.length === 1 && values.Plaque3?.length === 3 && values.Plaque4?.length === 2){
        onVehicleNoSet(values.Plaque1 + values.Plaque2 + values.Plaque3 + 'ايران' + values.Plaque4);
      }
      else{ onVehicleNoSet(""); }
    }
  }, [values])
  
  /*switch (letter) {
    case 'ع':
    case 'و':
    case 'ک':
    case 'ك': return '#ffbf00';
    case 'الف': return '#ee161f';

    case 'ت': return '#ffca0b';
    case 'پ': 
    case 'ث': return '#005224';
    case 'ش': return '#cfa260';
    case 'ز':
    case 'ف': return '#0079c1';
    case 'D':
    case 'S': return '#00a2e8';
    default:
      return '#ffffff';
  }*/
 

  return (
      <div className="container-pelak" style={{fontSize:30 * fc, margin:0}}>
      <div className="license-plate" style={{ backgroundColor: getPelakBgColor(values.Plaque2) , color : getPelakColor(values.Plaque2)}}>
        <div className="blue-column">
          <div className="flag">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className="text">
            <div>I.R.</div>
            <div>IRAN</div>
          </div>
        </div>
        <span>
          <TextField
            id={values.vehicleNo + '0'}
            sx={{width:32}}
            label=""
            variant="standard"
            color="warning"
            inputMode='numeric'
            type='number'
            value={values.Plaque1}
            onChange={v => { onChangePlq1( v.currentTarget.value ) }}
            className={props.readonly ? 'readonly' : ''}
            inputProps={{ 
              maxLength: 2, 
              style: {fontSize: 25 * fc, height:29 * fc, fontWeight:'bold', textAlign: 'center', color : getPelakColor(values.Plaque2) },
              //className: props.readonly ? 'readonly' : '',
              readOnly: props.readonly
            }
            }
          />
        </span>
        <span className="alphabet-column">
          <TextField
            id={values.vehicleNo + '1'}
            sx={{width:20}}
            label=""
            variant="standard"
            color="warning"
            value={values.Plaque2}
            onChange={v => { onChangePlq2( v.currentTarget.value ) }}
            className={props.readonly ? 'readonly' : ''}
            inputProps={{ 
              maxLength: 1,
              style: {fontSize: 25 * fc, height:29 * fc, fontWeight:'bold', textAlign: 'center', color : getPelakColor(values.Plaque2)},
              //className: props.readonly ? 'readonly' : '',
              readOnly: props.readonly 
            }}
          />
        </span>
        <span>
          {/*۸۳۷*/}
          <TextField
            id={values.vehicleNo + '2'}
            sx={{width:40}}
            label=""
            variant="standard"
            color="warning"
            type='number'
            value={values.Plaque3}
            onChange={v => { onChangePlq3( v.currentTarget.value ) }}
            className={props.readonly ? 'readonly' : ''}
            inputProps={{ 
              maxLength: 3,
              style: {fontSize: 25 * fc, height:29 * fc, fontWeight:'bold', textAlign: 'center', color : getPelakColor(values.Plaque2)},
              //className: props.readonly ? 'readonly' : '',
              readOnly: props.readonly 
            }}
          />
        </span>
        <div className="iran-column">
          <span>ایــران</span>
          <strong ><TextField
            id={values.vehicleNo + '3'}
            sx={{width:28, height:20}}
            label=""
            variant="standard"
            color="warning"
            inputMode='numeric'
            type='number'
            value={values.Plaque4}
            onChange={v => { onChangePlq4( v.currentTarget.value ) }}
            className={props.readonly ? 'readonly' : ''}
            inputProps={{ 
              maxLength: 2,
              style: {fontSize: 21 * fc, height:21 * fc, fontWeight:'bold', textAlign: 'center', color : getPelakColor(values.Plaque2) },
              //className: props.readonly ? 'readonly' : '',
              readOnly: props.readonly
            }}
          /></strong>
        </div>
      </div>
    </div>
  )
}
export default IsePelak